{
  "success": {
    "analyses/setMovable": "Zaktualizowana analiza",
    "analyses/moveIntoPlan": "Analiza pomyślnie przeniesiona do planu",
    "analyses/remove": "Analiza została pomyślnie usunięta z planu",
    "analysisDefinitions/create": "Dodana nowa definicja analizy",
    "analysisDefinitions/edit": "Edytowana definicja analizy",
    "analysisDefinitions/remove": "Usunięta definicja analizy",
    "analysisDraft/create": "Dodana nowa wersja robocza analizy",
    "analysisDraft/edit": "Edytowana wersja robocza analizy",
    "samples/delete-unlocked": "Usunięte wszystkie niezaplanowane próbki",
    "assets/remove": "Instrument pomyślnie usunięty",
    "assets/create": "Dodany nowy instrument",
    "assets/edit": "Edytowany instrument",
    "competenceGroups/create": "Nowa grupa kompetencji pomyślnie utworzona",
    "competenceGroups/edit": "Grupa kompetencji pomyślnie edytowana",
    "competenceGroups/remove": "Grupa kompetencji pomyślnie usunięta",
    "iap/run": "IAP pomyślnie uruchomiony",
    "iap/runFillInSamples": "Próbki pomyślnie uzupełnione",
    "integrationSheets/createActionSheet": "Arkusz dodany",
    "integrationSheets/createProjectTemplateSheets": "Arkusz dodany",
    "integrationSheets/createSampleSheet": "Arkusz dodany",
    "integrationSheets/editActionSheet": "Arkusz edytowany",
    "integrationSheets/editProjectTemplateSheet": "Arkusz edytowany",
    "integrationSheets/editSampleSheet": "Arkusz edytowany",
    "integrationSheets/removeActionSheet": "Arkusz usunięty",
    "integrationSheets/removeProjectTemplateSheet": "Arkusz usunięty",
    "integrationSheets/removeSampleSheet": "Arkusz usunięty",
    "integrationSheets/saveSapConversionSheet": "Arkusz Importu Projektu zapisany",
    "members/create": "Członek dodany",
    "members/createAsAdmin": "Członek dodany",
    "members/edit": "Członek edytowany",
    "members/archive": "Członek zarchiwizowany",
    "projectActions/editPlanned": "Działanie projektu edytowane",
    "projectActions/move": "Działanie projektu zostało zaplanowane",
    "projectActions/setMovable": "Działanie projektu zaktualizowane",
    "projectActions/setLocation": "Lokalizacja zaktualizowana",
    "projectActions/setLocationUnplanned": "Lokalizacja zaktualizowana",
    "projectActions/editUnplanned": "Niezaplanowane działanie projektu edytowane",
    "projectActions/removePlanned": "Działanie projektu zostało usunięte z planu",
    "projects/create": "Nowy projekt dodany",
    "projects/edit": "Projekt zaktualizowany",
    "projects/remove": "Projekt usunięty",
    "projects/delete-unplanned": "Wszystkie niezaplanowane projekty usunięte",
    "projects/lockProject": "Projekt zablokowany",
    "projects/unlockProject": "Projekt odblokowany",
    "projectTemplates/create": "Nowy szablon projektu utworzony",
    "projectTemplates/createDraft": "Nowa wersja robocza szablonu projektu utworzona",
    "projectTemplates/edit": "Szablon projektu edytowany",
    "projectTemplates/editDraft": "Wersja robocza szablonu projektu edytowana",
    "projectTemplates/remove": "Szablon projektu usunięty",
    "whiteTasks/remove": "Zadanie pomyślnie usunięte",
    "whiteTasks/create": "Zadanie zostało utworzone",
    "whiteTasks/edit": "Zadanie pomyślnie edytowane",
    "whiteTasks/createRecurrence": "Powtórzenie utworzone",
    "whiteTasks/removeRecurrence": "Powtarzające się zadania usunięte",
    "teamStatus/start": "Wejście w Tryb Symulacji",
    "teamStatus/accept": "Zmiany Trybu Symulacji zastosowane",
    "teamStatus/discard": "Zmiany Trybu Symulacji odrzucone",
    "customers/addCustomer": "Klient dodany",
    "customers/editCustomer": "Klient edytowany",
    "customers/deleteCustomer": "Klient usunięty",
    "team/create-api-token": "Token API utworzony",
    "team/delete-api-token": "Token API usunięty"
  },
  "error": {
    "analyses/remove/ERROR": "Nie udało się usunąć analizy z planu",
    "analysisDefinitions/create/ERROR": "Błąd dodawania nowej definicji analizy",
    "analysisDefinitions/remove/ERROR": "Błąd usuwania definicji analizy",
    "assets/remove/ERROR": "Błąd usuwania instrumentu",
    "assets/create/ERROR": "Błąd dodawania instrumentu",
    "auth/login/ERROR": "Błąd logowania",
    "competenceGroups/create/ERROR": "Błąd tworzenia grupy kompetencji",
    "competenceGroups/remove/ERROR": "Błąd usuwania grupy kompetencji",
    "iap/run/ERROR": "Błąd uruchomienia IAP",
    "iap/runFillInSamples/ERROR": "Błąd uzupełniania próbek",
    "integrationSheets/createActionSheet/ERROR": "Błąd dodawania arkusza",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Błąd dodawania arkusza",
    "integrationSheets/createSampleSheet/ERROR": "Błąd dodawania arkusza",
    "integrationSheets/editActionSheet/ERROR": "Błąd edytowania arkusza",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Błąd edytowania arkusza",
    "integrationSheets/editSampleSheet/ERROR": "Błąd edytowania arkusza",
    "integrationSheets/removeActionSheet/ERROR": "Błąd podczas usuwania arkusza",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Błąd podczas usuwania arkusza",
    "integrationSheets/removeSampleSheet/ERROR": "Błąd podczas usuwania arkusza",
    "loading/fetchAll/ERROR": "Błąd ładowania",
    "members/create/ERROR": "Błąd dodawania członka",
    "members/createAsAdmin/ERROR": "Błąd dodawania członka",
    "members/archive/ERROR": "Błąd archiwizacji członka",
    "projectActions/move/ERROR": "Błąd przenoszenia działania na harmonogram",
    "projectActions/removePlanned/ERROR": "Nie udało się usunąć działania z planu",
    "projectActions/setLocation/ERROR": "Błąd aktualizacji lokalizacji",
    "projectActions/setLocationUnplanned/ERROR": "Błąd aktualizacji lokalizacji",
    "projects/create/ERROR": "Błąd dodawania nowego projektu",
    "projects/remove/ERROR": "Błąd usuwania projektu",
    "projects/delete-unplanned/ERROR": "Błąd usuwania niezaplanowanych projektów",
    "projects/lockProject/ERROR": "Błąd blokowania działań",
    "projectTemplates/create/ERROR": "Błąd tworzenia nowego szablonu projektu",
    "projectTemplates/createDraft/ERROR": "Błąd tworzenia nowej wersji roboczej szablonu projektu",
    "projectTemplates/remove/ERROR": "Błąd usuwania szablonu projektu",
    "whiteTasks/remove/ERROR": "Błąd usuwania zadania",
    "whiteTasks/create/ERROR": "Nie udało się utworzyć zadania",
    "teamStatus/start/ERROR": "Błąd wejścia w Tryb Symulacji",
    "teamStatus/accept/ERROR": "Błąd zastosowania zmian Trybu Symulacji",
    "teamStatus/discard/ERROR": "Błąd odrzucenia zmian Trybu Symulacji",
    "customers/deleteCustomer/ERROR": "Nie można usunąć klienta",
    "customers/addCustomer/ERROR": "Nie można dodać klienta",
    "customers/editCustomer/ERROR": "Nie można edytować klienta",
    "team/create-api-token/ERROR": "Nie można utworzyć tokenu API",
    "team/delete-api-token/ERROR": "Nie można usunąć tokenu API"
  },
  "adhoc": {
    "welcomeBack": "Witaj ponownie!",
    "noSoundDetected": "Nie wykryto dźwięku. Spróbuj ponownie.",
    "noMicrophoneDetected": "Nie wykryto mikrofonu. Spróbuj ponownie.",
    "iapRunning": "Jedna chwila - IAP dla Twojego zespołu jest uruchamiany",
    "failedDiscardNotLoggedOut": "Błąd odrzucenia zmian. Nie zostałeś wylogowany!",
    "cannotDragRecurrentTask": "Nie możesz przeciągać i upuszczać powtarzającego się szarego zadania",
    "cannotMoveImportedTasks": "Nie możesz przenosić zaimportowanych zadań",
    "noCheckboxesSelected": "Nie wybrano żadnych pól wyboru",
    "analysisUpdatedRefresh": "Analiza została zaktualizowana, odśwież stronę",
    "analysisUpdatedByAnotherUser": "Analiza została zaktualizowana przez innego użytkownika, odśwież stronę",
    "copiedToClipboard": "Skopiowano do schowka",
    "couldNotCopyToClipboard": "Nie można skopiować do schowka",
    "chooseFirstAction": "Proszę wybrać pierwsze {{itemType}}",
    "chooseSecondAction": "Proszę wybrać drugie {{itemType}}",
    "chooseTwoDifferent": "Proszę wybrać dwa różne {{itemType}}",
    "constraintConflicts": "To ograniczenie jest w konflikcie z istniejącymi",
    "sampleCreated": "Próbka utworzona",
    "sampleDeleted": "Próbka usunięta",
    "samplesUpdated": "Próbki zaktualizowane",
    "sampleMarkedDone": "Próbka oznaczona jako gotowa",
    "memberPermissionsChanged": "Uprawnienia członka zmienione",
    "chooseUniqueName": "Proszę wybrać unikalną nazwę",
    "fillRequiredFields": "Proszę wypełnić wymagane pola",
    "couldNotDetermineSampleIdDone": "Nie można określić identyfikatora próbki do oznaczenia jako gotowa",
    "couldNotDetermineSampleIdDelete": "Nie można określić identyfikatora próbki do usunięcia",
    "couldNotDetermineSampleIdDeleteMissing": "Nie można określić identyfikatora próbki do usunięcia - brakujące dane. Sprawdź konsolę, aby uzyskać szczegóły.",
    "anErrorOccurred": "Wystąpił błąd",
    "selectFileBeforeSubmitting": "Proszę wybrać co najmniej jeden plik przed wysłaniem",
    "helpPageUpdated": "Strona pomocy zaktualizowana",
    "processingStarted": "Przetwarzanie rozpoczęte",
    "failedLoadingIcalFiles": "Błąd ładowania plików iCalendar",
    "unsortBeforePasting": "Przed wklejeniem wielu komórek wyłącz sortowanie tabeli.",
    "fillAllRequiredFields": "Proszę wypełnić wszystkie wymagane pola",
    "unsavedChangesConfirmLeave": "Masz niezapisane zmiany. Aby potwierdzić, że chcesz wyjść, naciśnij przycisk wstecz ponownie.",
    "provideSheetName": "Proszę podać Nazwę Arkusza",
    "sheetNameAlreadyExists": "Arkusz o tej nazwie już istnieje",
    "provideSheetType": "Proszę podać Typ Arkusza",
    "didNotSpellDeleteProperly": "Nie wpisałeś DELETE prawidłowo",
    "domainMustStartWithAt": "Domena musi zaczynać się od '@'",
    "fillOutRequiredFields": "Proszę wypełnić wymagane pola",
    "selectValidDates": "Proszę wybrać prawidłowe daty",
    "noIapModeSelected": "Nie wybrano trybu IAP. Proszę wybrać tryb.",
    "oneCollaboratorForWorkday": "Przy sprawdzaniu całego dnia roboczego można wybrać tylko jednego współpracownika",
    "fillRequiredDateTimeFields": "Proszę wypełnić wszystkie wymagane pola daty i godziny",
    "endMustBeAfterStart": "Koniec zadania musi być po starcie",
    "recurrencesCannotExceed365": "Liczba powtórzeń nie może być większa niż 365",
    "pleaseFillNumberAndInterval": "Proszę wypełnić liczbę i interwał powtórzeń",
    "pleaseFillNumberOfRecurrences": "Proszę wypełnić liczbę powtórzeń",
    "pleaseFillIntervalOfRecurrences": "Proszę wypełnić interwał powtórzeń",
    "pleaseFillAllPeriodFields": "Proszę wypełnić wszystkie pola okresu",
    "pleaseSelectReportType": "Proszę wybrać co najmniej jeden typ raportu",
    "reportEmptyInInterval": "{{fileName}} jest pusty w podanym interwale",
    "promptTooLong": "Prompt jest zbyt długi (maksymalnie 1200 znaków)",
    "nameTooLong": "Nazwa zbyt długa (maksymalnie 100 znaków)"
  }
}